import { configureStore } from "@reduxjs/toolkit";
import wizardSlice from "@/store/features/wizardSlice";

export const makeStore = () => {
  return configureStore({
    reducer: {
      wizard: wizardSlice,
    },
    devTools: true,
  });
};

// Infer the type of makeStore
type AppStore = ReturnType<typeof makeStore>;
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<AppStore["getState"]>;
export type AppDispatch = AppStore["dispatch"];

export type HubspotUser = {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
};

export type SessionPayload = {
  user: HubspotUser;
  session: any;
  workflow: any;
};

export type WizardStep = {
  id?: string;
  order: number;
  text?: string;
  pandadoc?: string;
  vimeo?: string;
  secondaryOnboardingUrl?: string;
  oncehubDocId?: string;
  orderformproduct?: string;
  thankyoutitle?: string;
  thankyoutext?: string;

  markdown?: string;
  hubspotMeetingSlug?: string;

  done?: boolean;
  data?: any;
  stepNumber?: number;

  orderformurl?: string;
};

export type WizardSteps = {
  [key: string]: WizardStep;
};
